import * as React from "react";
const SvgFiRrQ = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-q_svg__a)">
      <path
        fill="#062147"
        d="m22.707 22.293-2.54-2.541A9.94 9.94 0 0 0 22 14v-4C21.496-3.251 2.5-3.241 2 10v4c-.065 8.706 10.661 13.26 16.851 7.265l2.442 2.442c.93.92 2.335-.486 1.414-1.414M12 22c-4.41 0-8-3.59-8-8v-4C4.377-.591 19.627-.583 20 10v4a7.94 7.94 0 0 1-1.273 4.313l-2.02-2.02c-.929-.921-2.335.486-1.414 1.414l2.144 2.144A7.96 7.96 0 0 1 12 22"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-q_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrQ;
